import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import { COLORS, THEME_COLOR_VARIABLE_NAME } from '../../static/constants'
import FormItem from './_layouts/FormItem'

interface IProps {
  name: string
  value: string
  readonly?: boolean
  label?: null | string
  placeholder?: null | string
  error?: null | string
  required?: boolean
  password?: boolean
  pattern?: string
  onChangeHandler?(event: any): void | Promise<void>
  onBlurHandler?(event: any): void | Promise<void>
}

const InputTextV2: React.FC<IProps> = ({
  name,
  value,
  readonly,
  label,
  placeholder,
  error,
  required,
  password,
  pattern,
  onChangeHandler,
  onBlurHandler,
}) => {
  return (
    <FormItem label={label} required={required} error={error}>
      <S.Input
        id={name}
        type={password ? 'password' : 'text'}
        name={name}
        placeholder={placeholder}
        required={required ? true : false}
        value={value}
        pattern={pattern}
        onChange={event => {
          if (typeof onChangeHandler === 'function') {
            onChangeHandler(event)
          }
        }}
        onBlur={event => {
          if (typeof onBlurHandler === 'function') {
            onBlurHandler(event)
          }
        }}
        readOnly={readonly || false}
      />
    </FormItem>
  )
}

const S: { [key: string]: AnyStyledComponent } = {}

S.Input = styled.input`
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: solid 1px ${COLORS.Border};
  border-radius: 4px;
  font-size: 15px;
  transition: border 0.2s ease;
  outline: none;
  background: none;

  &:not([readonly]):focus {
    border: solid 1px var(${THEME_COLOR_VARIABLE_NAME});
  }

  &[readonly] {
    background-color: ${COLORS.Border};
    color: #888;
  }
`

export default InputTextV2
